module.exports = __webpack_public_path__ + "static/img/weixin.98c3d96.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/footer/weixin.jpg
// module id = f7Ey
// module chunks = 0